import fetch from "../axios/index"
import env from '../../build/env'


/*
*通用API接口
* url:请求路径
* method：请求方法（post\get\delete）
* data：请求对象
 */

let host = env === 'development' ? '' : ''
let prefix = '/api/'
let url = host + prefix
export function apiFetch(api) {
  if (api.headers) {
    return fetch({
      baseURL: url,
      url: api.url,
      method: api.method,
      data: api.data,
      responseType: api.responseType,
      headers: api.headers
    });
  } else {
    return fetch({
      baseURL: url,
      url: api.url,
      method: api.method,
      data: api.data,
      responseType: api.responseType,
    });
  }
}



// WEBPACK FOOTER //
// ./src/axios/api.js